<template>
    <div class="upload-wrapper">
        <div class="upload-preview">
            <ul class="upload-preview-list">
                <li class="upload-preview-item" :class="[type == 'video' && 'upload-preview-video-item']" v-for="(item, index) in addFiles" :key="index">
                    <img :src="item.link" alt="" v-if="type == 'image' && item.link">
                    <video :src="item.link" v-if="type == 'video' && item.link" controls></video>
                    <div class="upload-preview-file-icon" v-if="type == 'file'">
                        <img src="../assets/icon/icon_upload_file.svg" alt="pdf文件图标">
                    </div>
                    <span class="icon iconfont remove" @click="removeItem($event, index)">&#xe780;</span>
                    <span class="progress" v-if="item.percent < 100">{{item.percent}}%</span>
                    <span>{{item.link}}</span>
                </li>
                <li>
                    <button class="upload-btn">
                        <span class="icon iconfont add" :id="btnId" v-show="addFiles.length < maxlen">&#xe781;</span>
                        <input type="file" :multiple="maxlen && maxlen > 1" :accept="getAccept(type)" @change="change($event)">
                    </button>
                </li>
            </ul>
        </div>
        <input type="hidden" :value="value" :name="field" :data-required="required" :data-percent="percent">       
    </div>
</template>

<script>
import * as qiniu from 'qiniu-js'
import axios from 'axios'
import CONFIG from '../utils/config'
import COVER from '../utils/COVER'

export default {
    data() {
        return {
            btnId: 'uploadBtn_' + new Date().getTime() + Math.ceil(Math.random()*1000),
            addFiles: [],
            value: '',
            percent: 0,
        }
    },
    props: ['type', 'maxlen', 'field', 'required'],
    created() {
        this.aid = this.$route.query.id || ''
    },
    methods: {
        getAccept() {
            if (this.type === 'image') {
                return 'image/*'
            }

            if (this.type === 'video') {
                return 'video/*'
            }

            if (this.type === 'file') {
                return this.regexp || '.pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx'
            }

            return '';
        },
        change(e) {
            const filesList = e.target.files
            for (let i = 0;  i < filesList.length; i++) {
                this.upload(filesList[i], i + this.addFiles.length);
            }
        },
        upload(file, index) {
            this.getToken().then((res) => {
              const token = res.data.token;
              this.$set(this.addFiles, index, {
                    link: '',
                    percent: 0,
                })
              if (token && token.type === 'huawei') {
                this.huaweiUpload(file, token, index)
                return;
              }
              this.qiniuUpload(file, token, index)
            })
        },
        qiniuUpload(file, token, index) {
            let _this = this
            let observable = qiniu.upload(file, null, token, {}, {forceDirect: true})
            _this.percent = 1;
            
            let subscription = observable.subscribe({
                next(res){
                    const percent = res.total ? Math.ceil(res.total.percent) : 0;
                    _this.$set(_this.addFiles, index, {
                        link: '',
                        percent,
                    })

                    _this.percent = percent;
                },
                error(err){
                    _this.$set(_this.addFiles, index, {
                        link: '',
                        percent: 0,
                    })
                    if(err.code == 614) {
                        _this.$emit('dialogDataEvent', '图片格式错误')
                    } else if(err.code == 413) {
                        _this.$emit('dialogDataEvent', '上传图片过大')
                    } else if(err.code == 401) {
                        _this.$emit('dialogDataEvent', '页面过期，请重新打开')
                    } else {
                        _this.$emit('dialogDataEvent', '网络错误，上传失败~')
                    }
                },
                complete(res){
                    _this.$set(_this.addFiles, index, {
                        link: CONFIG.QINIUDOMAIN + res.key,
                        percent: 100,
                    })
                    _this.getUploadData()
                }
            })
        },
        async huaweiUpload(file, info, index) {
          let formData = new FormData();
          formData.append('token', info.token);
          formData.append('key', info.key);
          formData.append('file', file);
          const res = await axios({
            url: info.action,
            method: 'POST',
            transformRequest: [function(data, headers) {
              delete headers.post['Content-Type']
              return data
            }],
            data: formData,
          });

          console.log(res);
          if (res.status === 200 || res.status === 204) {
            this.$set(this.addFiles, index, {
                link: CONFIG.HUAWEIDOMAIN + info.key,
                percent: 100,
            })
            this.getUploadData()
          }
        },
        removeItem(e, index) {
            this.addFiles.splice(index, 1)
            this.getUploadData();
            this.percent = 0;
        },
        getToken() {
            let userinfo = sessionStorage.getItem('COVER_USERINFO');
            return COVER.$get('/upload/token', {
                aid: this.aid,
                token: userinfo ? JSON.parse(userinfo).token || 'none' : 'none'
            })
        },
        getUploadData() {
            let links = [];
            let percent = 100;
            this.addFiles.forEach((file, i) => {
                links.push(file.link);
                if (file.percent < 100) {
                    percent = file.percent;
                }
            });
            this.value = links.join(',')
            this.percent = percent;
        }
    }
}
</script>

<style lang="less" scoped>
    .upload-wrapper {
        border: 2px dashed #ccc;
        border-radius: 0.05rem;
        text-align: center;
        padding: 0.3rem 0;
    }
    .upload-btn {
        appearance: none;
        border: none;
        background: none;
        outline: none;
        position: relative;
        input {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            opacity: 0;
        }
    }
    .add {
        font-size: 1.5rem;
        color: #999;
    }
    .upload-preview-list {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
    }
    .upload-preview-item {
        width: 2.8rem;
        height: 2.8rem;
        border-radius: 0.2rem;
        overflow: hidden;
        position: relative;
        margin: 0 0.1rem 0.3rem;
        box-sizing: border-box;
        border: 1px solid #ccc;
        &.upload-preview-video-item {
            width: 5rem;
            height: 4rem;
        }
        img {
            display: block;
            position: relative;
            top: 50%;
            transform: translateY(-50%);
        }
        video {
            width: 100%;
            height: 100%;
        }
        .remove {
            font-size: 0.8rem;
            position: absolute;
            right: 0;
            top: 0;
            color: #f04134;
        }
        .progress {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0,0,0,0.7);
            font-size: 0.5rem;
            color: #fff;
            justify-content: center;
            display: flex;
            align-items: center;
        }
        .upload-preview-file-icon {
            img {
                width: 2.8rem;
                height: 2.8rem;
                transform: translate(0);
            }
        }
    }
</style>